import { configureStore } from '@reduxjs/toolkit';
import acessos from './acessos';
import assinatura from './assinatura';
import autenticacao from './autenticacao';
import hcaptcha from './hcaptcha';
import consultivo from './consultivo';
import consultivoFiltro from './consultivoFiltro';
import consultivoOperacional from './consultivoOperacional';
import consultivoCartoes from './consultivoCartoes';
import consultivoPesquisa from './consultivoPesquisa';
import societarioDashboard from './societarioDashboard';
import regulatorioDashboard from './regulatorioDashboard';
import complianceDashboard from './complianceDashboard';
import drive from './drive';
import empresa from './empresa';
import empresas from './empresas';
import i18n from './i18n';
import layout from './layout';
import loading from './loading';
import societarioFiltro from './societarioFiltro';
import societarioTabela from './societarioTabela';
import regulatorioFiltro from './regulatorioFiltro';
import regulatorioTabela from './regulatorioTabela';
import complianceFiltro from './complianceFiltro';
import complianceTabela from './complianceTabela';
import workflows from './workflows';
import workflow from './workflow';
import consultivoArea from "./consultivoArea";
import consultivoConsulta from "./consultivoConsulta";
import consultivoDashboard from "./consultivoDashboard";
import dataAnalytics from "./dataAnalytics";

export function createStore(isDev) {
  return configureStore({
    reducer: {
      loading,
      autenticacao,
      assinaturas: assinatura,
      hcaptcha,
      i18n,
      acessos,
      empresas,
      empresa,
      societarioDashboard,
      societarioFiltro,
      societarioTabela,
      regulatorioDashboard,
      regulatorioFiltro,
      regulatorioTabela,
      complianceDashboard,
      complianceFiltro,
      complianceTabela,
      consultivo,
      consultivoArea,
      consultivoConsulta,
      consultivoFiltro,
      consultivoDashboard,
      consultivoPesquisa,
      consultivoCartoes,
      consultivoOperacional,
      drive,
      layout,
      workflows,
      workflow,
      dataAnalytics,
    },
    devTools: isDev,
  });
}

export function unwrapResult(actionResult) {
  if (actionResult?.error) {
    if (actionResult?.payload)
      return Promise.reject(actionResult.payload);
    return Promise.reject(actionResult.error);
  }
  return Promise.resolve(actionResult?.payload);
}
